import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useState, useEffect } from "react";

// components
import Header from "./components/organisms/Header";
import Footer from "./components/organisms/Footer";
import HomeScreen from "./screens/HomeScreen";
import PortraitScreen from "./screens/PortraitScreen";
import UrbanScreen from "./screens/UrbanScreen";
import NatureScreen from "./screens/NatureScreen";
import ProjectScreen from "./screens/ProjectScreen";
import RetouchScreen from "./screens/RetouchScreen";
import ContactScreen from "./screens/ContactScreen";

function App() {
  // hooks
  // state
  const [loading] = useState(false);

  // useEffect
  useEffect(() => {
    document.title = "SFW";
  }, []);

  return (
    <div className="App">
      {loading ? (
        <p>Loading...</p>
      ) : (
        <Router>
          <Header />
          <Routes>
            <Route exact path="/" element={<HomeScreen />} />
            <Route path="/portraits" element={<PortraitScreen />} />
            <Route path="/nature" element={<NatureScreen />} />
            <Route path="/urban" element={<UrbanScreen />} />
            <Route path="/projects" element={<ProjectScreen />} />
            <Route path="/retouching" element={<RetouchScreen />} />
            <Route path="/contact" element={<ContactScreen />} />
          </Routes>

          <Footer />
        </Router>
      )}
    </div>
  );
}

export default App;
